import React from 'react';

export const formatFloatWithSuperscript = (floatNumber) => {
    const numStr = parseFloat(floatNumber).toFixed(2).toString();
    const parts = numStr.split('.');
    if (parts.length < 2) {
        return numStr;
    }
    if (parts[1] === '00') {
        return parts[0];
    }
    return (<>{parts[0]}<sup>{parts[1]}</sup></>);
};
export default formatFloatWithSuperscript;
